import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { useEffect, useRef } from "react";
import React from "react";
import useAppState from "context/useAppState";

const StackedBarChart = () => {
  const {
    setState,
    downloadChart,
    downloadChartName,
    chartName
  } = useAppState("eventData");

  const chartRef = React.useRef<any>(null);

  useEffect(() => {
    if (downloadChart) {
      downloadAsSVG()
      setState({ downloadChart: false })
    }
  }, [downloadChart])

  const downloadAsSVG = async () => {
    if (chartRef.current && chartName == 'stack_bar_chart') {
      try {
        await chartRef.current.chart.exports.exportToSVG(); // Use getSVGString for SVG data
      } catch (error) {
        console.error("Error downloading chart:", error);
      }
    }
  };

  const series = [
    {
      name: "Positive Feedback",
      data: [100, 55, 41, 67],
    },
    {
      name: "Negative Feedback",
      data: [13, 23, 20, 8],
    },
  ];

  const chartOptions: ApexOptions = {
    chart: {
      width: '400px',
      height: '400px',
      type: "bar",
      stacked: false,
      toolbar: {
        show: false,
        export: {
          svg: {
            filename: downloadChartName
          }
        }
      },
      zoom: {
        enabled: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 0,
        columnWidth: 16,
      },

    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: ["Venue", "F&B", "Gifts", "A/V"],
    },
    yaxis: {
      labels: {
        show: false,
      },
    },
    legend: {
      show: false,
    },
    fill: {
      opacity: 1,
    },
    colors: ["#1E0AF5", "#EAECF0"],
    tooltip: {
      enabled: false,
    },
    states: {
      hover: {
        filter: {
          type: 'none',
        }
      },
    }
  };

  return (
    <div className="insight-chart-wrapper">
      <ReactApexChart ref={chartRef} options={chartOptions} series={series} type="bar" height={150} />
    </div>
  );
};

export default StackedBarChart;
